//Regex to check if a given string is html or not
export const htmlRegexCheck = /<(?=.*? .*?\/ ?>)[a-z]+.*?>|<([a-z]+).*?<\/\1>/i